<template>
  <b-button @click="copyToClipboard" sm variant="primary-link" class="copy-button">
    <b-icon-clipboard-check class="text-success" v-if='justCopied'></b-icon-clipboard-check><b-icon-clipboard-plus class="text-secondary" v-else size="is-small"></b-icon-clipboard-plus>
  </b-button>
</template>

<script>
  export default {
      name: "CopyToClipboard",
      props: [ 'value'],
      data() {
          return {
              justCopied: false,
          }
      },
      methods: {
        copyToClipboard() {
          navigator.clipboard.writeText(this.value);
          this.justCopied = true;
          setTimeout(() => {
            this.justCopied = false;
          }, 2000);
        }
      }
    }
</script>

<style scoped>

.copy-button:active,
.copy-button:focus,
.copy-button.active,
.copy-button:active:focus {
   background-image: none;
   outline: 0;
   -webkit-box-shadow: none;
   box-shadow: none;
}
  .copy-button {
    padding: 0;
    margin: 0;
    outline: 0;
  }
</style>